export default __webpack_public_path__ + "static/media/facebook.dee94d71.svg";